export const throttle = (func, delay) => {
  let lastArgs = null;
  let lastThis = null;
  let timeoutId = null;

  function trailingCall() {
    // If there are arguments saved, it means a call was made during the cooldown.
    if (lastArgs) {
      func.apply(lastThis, lastArgs);
      // Clear the args and 'this' context
      lastArgs = null;
      lastThis = null;

      // Set another timeout to ensure the next call is throttled too
      timeoutId = setTimeout(trailingCall, delay);
    } else {
      // No more pending calls, so we can allow the next leading call to happen.
      timeoutId = null;
    }
  }

  return function (...args) {
    // Save the latest arguments and 'this' context
    lastArgs = args;
    lastThis = this;

    // If no timeout's running, we aren't in cooldown period.
    // Execute the leading call immediately.
    if (!timeoutId) {
      // Fire the leading call and clear the saved args since they were just used.
      func.apply(lastThis, lastArgs);

      lastArgs = null;
      lastThis = null;

      // Start the cooldown timer. When it's done, it will check for a trailing call.
      timeoutId = setTimeout(trailingCall, delay);
    }
    // If a timeout is running, do nothing but let the lastArgs be updated.
    // The trailingCall function will pick it up when the timeout completes.
  };
};
